import api from '@/api'

export default {
  title: '员工列表',
  api: api.staff.list,
  filters: [
    {
      label: '员工姓名',
      field: 'name',
      placeholder: '',
    },
    {
      label: '手机号码',
      field: 'mobile',
    },
  ],
  actions: [
    {
      title: '创建员工',
      route: 'staff_new',
    },
  ],
  table: {
    fields: [
      {
        key: 'name',
        label: '员工姓名',
      },
      {
        key: 'mobile',
        label: '手机号码',
      },
      {
        label: '所在门店',
        key: 'store.name',
      },
      {
        key: 'is_admin',
        label: '是否为管理员',
      },
    ],
    operations: [
      {
        title: '查看',
        type: 'DETAIL',
        route: 'staff_detail',
      },
      {
        title: '编辑',
        type: 'EDIT',
        route: 'staff_edit',
      },
      {
        title: '删除',
        api: api.staff.delete,
        type: 'DELETE',
      },
    ],
  },
}
